// Keep entrance and interaction motion consistent across the public site.
export const motionTokens = {
  enter: 0.45,
  fast: 0.18,
  ease: [0.22, 1, 0.36, 1],
};
